import styled from '@emotion/styled';
import { Button, Col, Form, Image, Input, Row, notification } from 'antd';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import loginBG from '../../../../assets/images/im1.jpg';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { createUser } from '../../../../redux/userStore/actions';
import { UserStateType } from '../../../../redux/userStore/reducer';
import { ROUTES } from '../../../../routes';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { signIn, verify } from '../../../login/network';
import { checkProfile } from '../../../shared/ProtectedRoutes';

const Container = styled.div`
  min-height: 500px;
  background-image: url(${loginBG});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;

  > div {
    background-color: rgba(19, 23, 34, 0.85);
    height: 500px;
    display: flex;
    // flex-direction: column;
    // justify-content: center;
    align-items: center;

    > .box {
      font-size: 35px;
      font-family: Poppins-R;
      padding: 30px !important;
    }

    > .box2 {
      width: 50%;
      font-size: 35px;
      font-family: Poppins-R;
      padding: 30px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
    }
  }
`;

type LayoutType = Parameters<typeof Form>[0]['layout'];

const SignInContainer = styled.div`
  font-family: Poppins-R;

  .ant-form-item-explain.ant-form-item-explain-error {
    font-size: 11px;
  }

  > div {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    > div {
      background-color: white;
      width: 100%;
      height: 410px;
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2),
        0 6px 20px 0 rgba(0, 0, 0, 0.19);
      padding: 20px;
      border-radius: 35px;
    }
  }

  @media (min-width: 768px) {
    padding: 0px;
    > div {
      > div {
        width: 100%;
      }
    }
  }
`;

export const Banner = () => {
  const connectedUser = new ConnectedUserEntity(
    useSelector((state: any) => state.userReducer).user,
  );
  const [form] = Form.useForm();
  const [formLayout] = useState<LayoutType>('vertical');
  const [isLoading, setIsLoading] = useState(false);
  const [isOtp, setisOTP] = useState(false);
  const [runningU, setRunningU] = useState<UserStateType | undefined>();
  const router = useHistory();
  const dispatch = useDispatch();

  const redirectToPage = () => {
    if (runningU) {
      dispatch(createUser(runningU));
      if (checkProfile(runningU.profils as any, 'admin')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'resp_commercial')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'commercial')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'responsable')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'chef_agence')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'gestionnaire')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      } else if (checkProfile(runningU.profils as any, 'sadmin')) {
        router.push(ROUTES.DASHBOARD.PAGE);
      }
    }
  };

  return (
    <Container>
      <Row gutter={18} style={{ display: 'flex', alignItems: 'center' }}>
        <Col xs={24} sm={24} md={7} xl={7}>
          <Image
            src='/assets/images/moranje-logo.png'
            width={'90%'}
            style={{
              objectFit: 'contain',
              marginTop: 20,
              marginBottom: 20,
            }}
            preview={false}
          />
        </Col>
        <Col
          xs={24}
          xl={connectedUser?.isConnected() ? 17 : 9}
          md={connectedUser?.isConnected() ? 17 : 9}
        >
          <p style={{ textAlign: 'center', fontSize: 40 }}>
            Transformons nos Ambitions en Obligations dans une Afrique Emergente
            avec
            <span
              style={{
                fontFamily: 'Poppins-B',
              }}
            >
              <span style={{ color: ORANGE }}>Moranj</span>
              <span style={{ color: '#6d4c41' }}>E</span>
              <span style={{ color: YELLOW }}>trade</span>
            </span>
          </p>
        </Col>
        <Col
          xs={0}
          xl={connectedUser?.isConnected() ? 0 : 8}
          md={connectedUser?.isConnected() ? 0 : 8}
          className={connectedUser?.isConnected() ? '' : 'box'}
        >
          <SignInContainer>
            <div>
              <div>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginBottom: 20,
                  }}
                >
                  <span
                    style={{
                      fontFamily: 'Poppins-B',
                      fontSize: 35,
                    }}
                  >
                    <span style={{ color: ORANGE }}>Moranj</span>
                    <span style={{ color: '#6d4c41' }}>E</span>
                    <span style={{ color: YELLOW }}>trade</span>
                  </span>
                </div>
                <Form
                  layout={formLayout}
                  form={form}
                  labelCol={{ span: 20 }}
                  wrapperCol={{ span: 25 }}
                  onFinish={async (data) => {
                    if (runningU) {
                      const { code }: { code: string } = data;
                      // if (code === '1234') {
                      //   redirectToPage();
                      // } else {
                      //   notification.error({
                      //     message: 'Erreur',
                      //     description: 'Code incorrect',
                      //   });
                      // }
                      // return;
                      await verify(runningU.email, code)
                        .then(async ({ statusCode, data }) => {
                          if (data.ok) {
                            redirectToPage();
                            // Tu peux rediriger vers une autre page ici
                          } else {
                            setRunningU(undefined);
                            notification.error({
                              message: 'Erreur',
                              description: data.error,
                            });
                          }
                        })
                        .catch((err) => {
                          setRunningU(undefined);
                          notification.error({
                            message: 'Erreur',
                            description: err.message || err,
                          });
                          setIsLoading(false);
                        });
                    } else {
                      setIsLoading(true);
                      const { email, password } = data;
                      await signIn(email, password)
                        .then(
                          ({
                            statusCode,
                            data,
                          }: {
                            statusCode: any;
                            data: any;
                          }) => {
                            if (statusCode.toString()[0] === '2') {
                              console.log(data);
                              setRunningU({
                                authentifie: true,
                                id: data.id,
                                agence: data.agence,
                                url: data.url,
                                nom: data.nom,
                                prenom: data.prenom,
                                email: data.email,
                                profils: data.profils,
                                manager: data.manager,
                                partenaire: data.partenaire,
                                token: '',
                                nextAuthDate:
                                  new Date().getTime() + 12 * 60 * 60 * 1000,
                                achat: 0,
                                vente: 0,
                              });
                              setisOTP(true);
                            } else {
                              notification.error({
                                message: 'Erreur',
                                description: data.message,
                              });
                              setIsLoading(false);
                            }
                          },
                        )
                        .catch((err: Error) => {
                          notification.error({
                            message: 'Erreur',
                            description: err.message,
                          });
                          setIsLoading(false);
                        });
                    }
                  }}
                >
                  {isOtp ? (
                    <>
                      <Form.Item
                        label='OTP'
                        name='code'
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: 'Le champ otp est requis',
                          },
                        ]}
                      >
                        <Input placeholder='Entrer le code otp reçu par SMS' />
                      </Form.Item>
                      <Form.Item>
                        <Button
                          type='primary'
                          htmlType='submit'
                          size='large'
                          style={{
                            width: '100%',
                            backgroundColor: ORANGE,
                            borderColor: PRIMARY,
                            borderWidth: 0,
                            marginBottom: 20,
                          }}
                        >
                          Verifier
                        </Button>
                      </Form.Item>
                    </>
                  ) : (
                    <>
                      <Form.Item
                        label='Email'
                        name='email'
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            type: 'email',
                            message: 'Le champ email est requis',
                          },
                        ]}
                      >
                        <Input placeholder='adresse mail' type='email' />
                      </Form.Item>
                      <Form.Item
                        label='Password'
                        name='password'
                        hasFeedback
                        rules={[
                          {
                            required: true,
                            message: 'Le mot de passe est requis',
                          },
                        ]}
                      >
                        <Input.Password placeholder='mot de passe' />
                      </Form.Item>

                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                          color: 'red',
                        }}
                      >
                        <p
                          style={{
                            textDecoration: 'underline',
                            cursor: 'pointer',
                            fontSize: 12,
                          }}
                        >
                          Mot de passe oublié ?
                        </p>
                      </div>

                      <Form.Item>
                        <Button
                          type='primary'
                          htmlType='submit'
                          size='large'
                          loading={isLoading}
                          style={{
                            width: '100%',
                            backgroundColor: ORANGE,
                            borderColor: PRIMARY,
                            borderWidth: 0,
                            marginBottom: 20,
                          }}
                        >
                          Connecter
                        </Button>
                      </Form.Item>
                    </>
                  )}
                </Form>
              </div>
            </div>
          </SignInContainer>
        </Col>
      </Row>
    </Container>
  );
};
